export default "__VITE_ASSET__456bcd0e__"